// v4 (spec-v4-structure-and-stage.md 5.2 + section 10): the one primary button a screen shows, from core's
// nextStep() (GET /api/projects/:id/next). Its blocker or error sits above it as a Notice and its price is on the
// button: neither is ever folded. "busy" shows a quiet line; "none" shows nothing.
import type { NextStepData } from "../nextstep";
import { Notice } from "./Notice";

/** Steps whose button is itself the fix for their blocker ("Pip needs an approved sheet" / "Approve Pip's sheet"). */
const BUTTON_FIXES: NextStepData["id"][] = ["make_sheet", "approve_sheet", "update_older_looks"];

/** Whether the blocker shows as its own Notice: not when the button right under it says the same thing (X3). */
export const showsBlocker = (step: NextStepData) => !!step.blocking && step.blocking.tone !== "info" && !(step.blocking.tone === "warning" && step.label && BUTTON_FIXES.includes(step.id));

export function NextStep({ step, onAct, pending = false }: { step: NextStepData | null; onAct: (s: NextStepData) => void; pending?: boolean }) {
  if (!step || step.id === "none") return null;
  return (
    <div className="next-step" data-step={step.id} aria-live="polite">
      {showsBlocker(step) && <Notice {...step.blocking!} />}
      {step.label ? (
        <div className="next-step-card">
          <span className="next-step-eyebrow">Next</span>
          {step.blocking?.tone === "info" && <span className="next-step-note">{step.blocking.text}</span>}
          <button data-action="project.next-step" type="button" className="btn btn-primary next-step-btn" disabled={pending} onClick={() => onAct(step)}>
            {step.label}
          </button>
        </div>
      ) : (
        <p className="next-step-quiet muted">{step.spoken}</p>
      )}
    </div>
  );
}
